import { useEffect, useState } from "react";

/**
 * Le bouton de qui présente, en mode démo (allumé depuis la console) : à une
 * table, il fait passer la tribu à l'étape suivante, puis rejoue la démo.
 * Invisible quand le mode est éteint.
 */

let actifConnu: boolean | null = null;

async function lireActif(): Promise<boolean> {
  try {
    const r = await fetch("/api/demo", { cache: "no-store" });
    if (!r.ok) return false;
    return ((await r.json()) as { actif?: boolean }).actif === true;
  } catch {
    return false;
  }
}

/** Le mode démo est-il allumé ? Relu toutes les dix secondes. */
export function useModeDemo(enTable: boolean): boolean {
  const [actif, setActif] = useState(actifConnu ?? false);
  useEffect(() => {
    if (!enTable) return;
    let vivant = true;
    const lire = (): void => {
      void lireActif().then((a) => {
        actifConnu = a;
        if (vivant) setActif(a);
      });
    };
    lire();
    const id = window.setInterval(lire, 10_000);
    return () => {
      vivant = false;
      window.clearInterval(id);
    };
  }, [enTable]);
  return enTable && actif;
}

async function poster(chemin: string, corps: Record<string, unknown>): Promise<boolean> {
  try {
    const r = await fetch(chemin, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(corps),
    });
    return r.ok;
  } catch {
    return false;
  }
}

/**
 * Chaque appui fait passer à l'écran suivant, celui de qui présente compris :
 * une question répondue à sa place, l'ouverture du chat, le rendez-vous, puis
 * l'arrivée de tout le monde (lui aussi), et enfin « Rejouer ».
 */
export function BoutonDemo(props: {
  sessionId: string;
  pid: string | null;
  fini: boolean;
  /** Ce qui se fait sur le téléphone (répondre à une question) ; `true` si c'est fait. */
  etapeLocale: () => boolean;
  /** Après le passage côté serveur (arriver soi-même au rendez-vous). */
  apres: () => void;
  onRejoue: () => void;
}): JSX.Element {
  const [occupe, setOccupe] = useState(false);
  const agir = async (): Promise<void> => {
    if (occupe) return;
    setOccupe(true);
    if (props.fini) {
      if (await poster("/api/demo/rejouer", { sessionId: props.sessionId })) props.onRejoue();
    } else if (!props.etapeLocale()) {
      await poster("/api/demo/avancer", { sessionId: props.sessionId, pid: props.pid });
      props.apres();
    }
    window.setTimeout(() => setOccupe(false), 500);
  };
  return (
    <button
      type="button"
      className="hoa-demo"
      disabled={occupe}
      aria-label={props.fini ? "Démo : rejouer" : "Démo : étape suivante"}
      title={props.fini ? "Rejouer" : "Étape suivante"}
      onClick={() => void agir()}
    >
      <span className="hoa-demo-tag">Démo</span>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {props.fini ? <path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" /> : <path d="M5 12h14M13 6l6 6-6 6" />}
      </svg>
    </button>
  );
}
